// DefaultPasswordBanner — persistent prompt on all authenticated pages
// in basic-auth mode until the operator rotates the default password.
// Silent in Supabase mode and when the password has been changed.

import { useAuth } from '@/lib/auth';

export function DefaultPasswordBanner() {
  const { mode, user, defaultPasswordWarning } = useAuth();

  // Show only when: basic mode, signed in, password still 'admin'.
  // Not dismissable — this is a real security issue and should stay
  // visible until fixed.
  if (mode !== 'basic' || !user || !defaultPasswordWarning) return null;

  return (
    <div role="alert" className="border-b border-del/30 bg-del/15 text-del">
      <div className="mx-auto flex max-w-6xl items-center gap-2 px-4 py-2 text-xs sm:px-6">
        <svg
          className="h-4 w-4 flex-shrink-0"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-5a1 1 0 112 0 1 1 0 01-2 0zm1-11a1 1 0 00-1 1v5a1 1 0 102 0V3a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <span>
          <strong className="font-semibold">Default password in use.</strong> Set{' '}
          <code className="font-mono">BASIC_AUTH_PASSWORD</code> in{' '}
          <code className="font-mono">.env</code> and restart — anyone on your network can currently
          sign in.
        </span>
      </div>
    </div>
  );
}
